import { formatError } from 'components/utils/FormatData';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { useAlert } from 'react-alert';
import axios from 'axios';
import React from 'react';
import useWindowSize from 'hooks/useWindowSize';

import { URL_API } from '../../constants/settings';

const TypeProfilRenderer = (props) => {
  const alert = useAlert();
  const [width, height] = useWindowSize();

  const handleChange = (event) => {
    if (props.data && props.data.login) {
      axios({ method: 'put', url: URL_API + '/utilisateurs/' + props.data.login + '/' + event.target.value })
        .then(function () {
          alert.success('Le rôle du compte [' + props.data.login + '] a été changé en [' + event.target.value + ']');
          props.setNeedUpdate(true);
        })
        .catch(function (err) {
          formatError(alert, err);
        });
    }
  };

  return (
    <FormControl>
      {
        props.wsStatus &&
        <Select value={props.value} onChange={handleChange} style={{ margin: '10px', minWidth: !isMobile ? '125px' : '75px' }}>
          <MenuItem value="ADMINISTRATEUR_FONCTIONNEL">Admin. fonctionnel</MenuItem>
          <MenuItem value="ADMINISTRATEUR_TECHNIQUE">Admin. technique</MenuItem>
          <MenuItem value="SUPERVISEUR">Superviseur</MenuItem>
          <MenuItem value="TECHNICIEN">Technicien</MenuItem>
        </Select>
      }
      {
        !props.wsStatus &&
        <Select value={props.value} onChange={handleChange} style={{ margin: '10px', minWidth: !isMobile ? '125px' : '75px' }} disabled>
          <MenuItem value="ADMINISTRATEUR_FONCTIONNEL">Admin. fonctionnel</MenuItem>
          <MenuItem value="ADMINISTRATEUR_TECHNIQUE">Admin. technique</MenuItem>
          <MenuItem value="SUPERVISEUR">Superviseur</MenuItem>
          <MenuItem value="TECHNICIEN">Technicien</MenuItem>
        </Select>
      }
    </FormControl>
  );

};

export default TypeProfilRenderer;